<div class="loading-shade" *ngIf="!well">
  <mat-spinner></mat-spinner>
</div>
<dl class="test" *ngIf="well">
  <div class="grid">
    <div class="column">
      <dd>Nombre de Pozo</dd>
      <dt>{{ well.wellCommonName }}</dt>
    </div>

    <div class="column">
      <dd>Yacimiento</dd>
      <dt>{{ well.project }}</dt>
    </div>

    <div class="column">
      <dd>País</dd>
      <dt>{{ well.locCountry }}</dt>
    </div>

    <div class="column">
      <dd>Provincia</dd>
      <dt>{{ well.locState }}</dt>
    </div>

    <div class="column">
      <dd>Distrito/Asset</dd>
      <dt>{{ well.districtName }}</dt>
    </div>

    <div class="column">
      <dd>Unidad de Gestión</dd>
      <dt>{{ well.ug }}</dt>
    </div>
  </div>

  <div class="coordenadas">
    <h3>
      <mat-icon class="material-icons-outlined">near_me</mat-icon>
      Coordenadas de Locación
    </h3>
    <div class="grid">
      <div class="column">
        <dd>X [m]</dd>
        <dt>{{ well.northing | number : "1.2-2" }}</dt>
      </div>

      <div class="column">
        <dd>Y [m]</dd>
        <dt>{{ well.easting | number : "1.2-2" }}</dt>
      </div>

      <div class="column">
        <dd>Z [m]</dd>
        <dt>{{ well.groundElevation | number : "1.2-2" }}</dt>
      </div>
    </div>
  </div>

  <div class="grid">
    <div class="column full">
      <dd>Nivel de Referencia</dd>
      <dt>{{ well.datum }}</dt>
    </div>

    <div class="column full">
      <dd>Altura de Nivel de Referencia [m]</dd>
      <dt>{{ well.datumElevation | number : "1.2-2" }}</dt>
    </div>

    <div class="column full">
      <dd>GAP entre Nivel de Terreno y Nivel de Referencia [m]</dd>
      <dt>{{ well.airGap | number : "1.2-2" }}</dt>
    </div>

    <div class="column">
      <dd>Fecha PEM</dd>
      <dt>{{ well.pemDate | date : "dd/MM/yyyy" }}</dt>
    </div>
    <div class="column">
      <dd>Fecha Abandono</dd>
      <dt>{{ well.abandonmentDate | date : "dd/MM/yyyy" }}</dt>
    </div>
    <div class="column">
      <dd>Fecha Perforación</dd>
      <dt>{{ well.drillingDate | date : "dd/MM/yyyy" }}</dt>
    </div>
    <div class="column">
      <dd>Profundidad [m]</dd>
      <dt>{{ well.depth | number : "1.2-2" }}</dt>
    </div>
    <div class="column">
      <dd>Inyección de Agua [m<sup>3</sup>]</dd>
      <dt>{{ well.waterInjection | number : "1.2-2" }}</dt>
    </div>
    <div class="column">
      <dd>Producción de Agua [m<sup>3</sup>]</dd>
      <dt>{{ well.water | number : "1.2-2" }}</dt>
    </div>
    <div class="column">
      <dd>Producción de Gas [m<sup>3</sup>]</dd>
      <dt>{{ well.gas | number : "1.2-2" }}</dt>
    </div>
    <div class="column">
      <dd>Producción de Petróleo [m<sup>3</sup>]</dd>
      <dt>{{ well.oil | number : "1.2-2" }}</dt>
    </div>
  </div>
</dl>
